import { render, staticRenderFns } from "./CalendarRemove.vue?vue&type=template&id=10e6bb32&"
import script from "./CalendarRemove.vue?vue&type=script&lang=js&"
export * from "./CalendarRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports